import { useState } from 'react'

import { useUserData } from '../../../hooks'
import { Chatroom } from '../../Chatroom'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'

import {
  getNewsboardPostProfileTabCommentsPermissions,
  isNewsboardPostCommentsDisabledForViewer,
} from './NewsboardPostProfileTabComments.utils'

import * as styles from './NewsboardPostProfileTabComments.module.css'

function NewsboardPostProfileTabComments() {
  const { handleEntityReload, postData } = useNewsboardPostProfileContext()

  const user = useUserData()

  const [chatUuid, setChatUuid] = useState(postData?.chat)

  // The post gains a chat only once the first comment is sent. Track the new
  // uuid locally so the freshly created chatroom keeps rendering, and reload
  // the post so the persisted `chat` reference stays in sync.
  function handleChatroomCreated(data) {
    setChatUuid(data?.uuid)
    handleEntityReload?.()
  }

  const postPermissions = getNewsboardPostProfileTabCommentsPermissions({
    postData,
    user,
  })

  return (
    <div className={styles.comments}>
      <Chatroom
        isPublic
        Header={null}
        createChatroomParams={{ post: postData?.uuid }}
        disableSend={isNewsboardPostCommentsDisabledForViewer({
          postData,
          user,
        })}
        key={chatUuid}
        requestPermissions={postPermissions}
        uuid={chatUuid}
        onChatroomCreated={handleChatroomCreated}
      />
    </div>
  )
}

export default NewsboardPostProfileTabComments
